import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {FeatureFlagResponse} from 'domain/usecases/private/check-features/get-check-features';
import {getLocalStorageFeatureFlags} from './fetch-feature-flag';

export function getFeatureFlagValue(flagName: string) {
	const queryCachedFlags: FeatureFlagResponse[] | undefined = queryClient.getQueryData([
		QUERY_KEYS.FEATURE_FLAGS,
		{excludeWalletCode: true},
	]);

	if (queryCachedFlags) {
		const flag = queryCachedFlags.find(featureFlag => featureFlag?.flag === flagName);
		return flag?.enabled ?? false;
	}

	const localStorageCache = getLocalStorageFeatureFlags();
	if (localStorageCache) {
		const flag = localStorageCache.data.find(featureFlag => featureFlag?.flag === flagName);
		return flag?.enabled ?? false;
	}

	return false;
}
